import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import withState from 'recompose/withState';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import History from '../components/History';
import {
  getPayoutReportHistoryFromRaw,
  getPayoutReportSummaryFromRaw,
  getPayoutReportPagination,
} from '../../../../main/reports/selectors';
import { fetchBarberPayoutsHistoryInitial, fetchBarberPayoutsHistoryMore } from '../../../../main/reports/actions';
import * as authSelectors from '../../../../auth/selectors';

const mapStateToProps = (state) => ({
  barberId: authSelectors.getBarberUserId(state),
  summary: getPayoutReportSummaryFromRaw(state),
  history: getPayoutReportHistoryFromRaw(state),
  pagination: getPayoutReportPagination(state),
});

const enhance = compose(
  connect(mapStateToProps),
  withState('showHistory', 'setShowHistory', false),
  withState('expanded', 'setExpanded', {}),
  withState('loading', 'setLoading', false),
  withState('hasMore', 'setHasMore', true),
  withHandlers({
    onLoadMore: (props) => async () => {
      if (props.loading || !props.hasMore) return;
      props.setLoading(true);
      await props.dispatch(fetchBarberPayoutsHistoryMore(props.barberId, props.pagination.skip));
      props.setLoading(false);
    },
  })
);

const EnhancedHistory = (props) => {
  const { barberId, dispatch, setHasMore, pagination } = props;

  useEffect(() => {
    if (barberId) {
      dispatch(fetchBarberPayoutsHistoryInitial(barberId));
      setHasMore(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [barberId]);

  useEffect(() => {
    setHasMore(pagination.hasMore);
  }, [pagination.hasMore, setHasMore]);

  return (
    <History
      summary={props.summary}
      history={props.history}
      showHistory={props.showHistory}
      setShowHistory={props.setShowHistory}
      expanded={props.expanded}
      setExpanded={props.setExpanded}
      onLoadMore={props.onLoadMore}
      hasMore={props.hasMore}
      loading={props.loading}
    />
  );
};

EnhancedHistory.propTypes = {
  dispatch: PropTypes.func.isRequired,
  barberId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  summary: PropTypes.array,
  setHasMore: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  pagination: PropTypes.object.isRequired,
  showHistory: PropTypes.bool.isRequired,
  setShowHistory: PropTypes.func.isRequired,
  expanded: PropTypes.object.isRequired,
  setExpanded: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func,
};

EnhancedHistory.defaultProps = {
  barberId: null,
  summary: [],
  onLoadMore: () => {},
};

export default enhance(EnhancedHistory);
